<section *ngIf="show" id="alertify-logs" class="alertify-logs">
    <article class="alertify-log alertify-log-{{ALERT[alert].toLowerCase()}} alertify-log-show">{{message}}</article>
</section>